const panelRequests = new Map();

function fetchPanel(collectionUrl) {
  const requestUrl = new URL(collectionUrl, window.location.href);
  requestUrl.searchParams.set('section_id', 'al-tabbed-collection-products');
  const cacheKey = requestUrl.toString();

  if (!panelRequests.has(cacheKey)) {
    panelRequests.set(
      cacheKey,
      fetch(cacheKey, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
        return response.text();
      })
    );
  }

  return panelRequests.get(cacheKey);
}

function addPricePrefix(container, prefix) {
  if (!prefix) return;

  container.querySelectorAll('.product-item__price').forEach((price) => {
    if (price.querySelector('.product-item__price-prefix')) return;
    const label = document.createElement('span');
    label.className = 'product-item__price-prefix';
    label.textContent = prefix;
    price.prepend(label, document.createTextNode(' '));
  });
}

function configureViewAllTile(container, button) {
  const tile = container.querySelector('.collection-view-all-tile-wrapper');
  if (!tile) return;
  if (button.dataset.showViewAll !== 'true') {
    tile.remove();
    return;
  }

  const heading = tile.querySelector('.section-blocks__heading');
  if (heading && button.dataset.viewTitle) heading.textContent = button.dataset.viewTitle;
  if (button.dataset.tileLocation === 'end') container.append(tile);
}

document.addEventListener(
  'click',
  async (event) => {
    const button = event.target.closest('[data-tab-button][data-al-tab-async]');
    if (!button || button.dataset.alTabLoaded === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.alTabLoading === 'true') return;

    button.dataset.alTabLoading = 'true';
    button.setAttribute('aria-busy', 'true');

    try {
      const key = button.dataset.showsCollectionKey;
      const section = button.closest('[data-section-type="tabbed-collections"]');
      const template = section?.querySelector(`template[data-template-key="${CSS.escape(key)}"]`);
      const slot = template?.content.querySelector('[data-al-tab-products-slot]');
      if (!template || !slot) throw new Error('Deferred tab template is missing');

      const markup = await fetchPanel(button.dataset.collectionUrl);
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const products = parsed.querySelector('[data-al-tab-products]');
      if (!products) throw new Error('Deferred tab products are missing');

      configureViewAllTile(products, button);
      addPricePrefix(products, button.dataset.pricePrefix || '');
      slot.replaceWith(...products.children);
      button.dataset.alTabLoaded = 'true';
      button.removeAttribute('data-al-tab-async');
      button.click();
    } catch (error) {
      console.error('Deferred collection tab failed', error);
      window.location.assign(button.dataset.collectionUrl);
    } finally {
      button.removeAttribute('aria-busy');
      delete button.dataset.alTabLoading;
    }
  },
  true
);
